import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Popover from '@/components/popover';
import { useStore } from '@/models';
import { NavLink, useHistory } from 'react-router-dom';
import ProfileIcon from '@/components/icons/ProfileIcon';
import AuthIcon from '@/components/icons/AuthIcon';
import DollarIcon from '@/components/icons/DollarIcon';
import Setting from '@/components/icons/Setting';
import DropDownProfileMenu from './components/DropDownProfileMenu';
import DropDownSettingMenu from './components/DropDownSettingMenu';
import cs from './index.module.scss';

const Profile: React.FC = () => {
  const { t } = useTranslation();
  const { account, ui, futures } = useStore();
  const {
    isLogin,
    userId,
    userName,
    accountInfo,
    toSignIn,
    toSignUp,
    toSignOut,
    userInfo,
    showEmail,
    showTel,
  } = account;
  const { theme } = ui;
  const { push } = useHistory();
  const { headPortrait } = userInfo;
  const [visible, setVisible] = useState(false);
  const widthMin = 180;
  const widthMax = 300;

  // Begin: 开通合约
  const showOpenAccountModal = () => {
    setVisible(true);
  };
  const hideOpenAccountModal = () => {
    setVisible(false);
  };
  // End: 开通合约

  // 0未认证，1初级认证 2 审核中 3 不通过
  const authLevel = (): number => (userInfo ? userInfo.idNoStatus : 0);

  const menuList = [
    {
      title: (
        headPortrait ? <img src={headPortrait} style={{ width: '24px', height: '24px', marginLeft: '18px' }} alt="" /> : <ProfileIcon style={{ color: theme === 'Dark' ? 'white' : 'white', fontSize: '44px', marginLeft: '18px' }} />
        // <ProfileIcon style={{ color: theme === 'Dark' ? 'white' : 'white', fontSize: '20px', marginLeft: '16px' }} />
      ),
      url: '/',
      children: [
        {
          isUser: true,
          url: '/account/profile/basic',
          slot: (
            <div style={{ position: 'relative', height: '16px' }}>
              <span>{`Hi, ${userName || ''}`}</span>
            </div>
          ),
        },
        {
          title: userId,
          isUser: true,
          slot: (
            <div
              style={{
                position: 'absolute',
                right: '-20px',
                top: '2px',
                fontSize: '12px',
                lineHeight: '20px',
                color: authLevel() === 1 ? '#ED0070' : '#b9b9ba',
                backgroundColor: authLevel() === 1 ? 'rgba(21, 113, 255, .1)' : 'rgba(185, 185, 186, .1)',
                borderRadius: '40px 0 0 40px',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
                width: 'auto',
                padding: '2px 10px',
                marginTop: 0,
              }}
            >
              {authLevel() === 0 && (
                <>
                  <AuthIcon color="#c4c4c4" />
                  {t('header.menu.unverified')}
                </>
              )}
              {authLevel() === 1 && (
                <>
                  <AuthIcon color="#ED0070" />
                  {t('header.menu.verified')}
                </>
              )}
              {authLevel() === 2 && (
                <>
                  <AuthIcon color="#F7e0c4" />
                  {t('header.menu.verifing')}
                </>
              )}
              {authLevel() === 3 && (
                <>
                  <AuthIcon color="#f4cdc9" />
                  {t('header.menu.verifiedFail')}
                </>
              )}
              <span style={{ marginLeft: '8px ' }} />
            </div>
          ),
        },
        { title: t('account.profile.security1'), url: '/account/profile/security' },
        { title: t('account.profile.verified'), url: '/account/profile/verified' },
        { title: t('account.profile.invite'), url: '/account/profile/invite' },
        // { title: t('account.profile.Vouchers'), url: getExchangeUrl().myVouchers },
        { title: t('account.profile.api'), url: '/account/profile/api' },
        { title: t('account.profile.logout'), onClick: toSignOut },
      ],
    },
  ];
  const orderMenuList = [
    {
      title: <DollarIcon />,
      url: '/',
      children: [
        { title: t('record.tab.01.title'), url: '/record/order' },
        { title: t('record.tab.02.title'), url: '/record/plan' },
        { title: t('record.tab.03.title'), url: '/record/order-history' },
        { title: t('record.tab.04.title'), url: '/record/fund' },
        { title: t('record.tab.05.title'), url: '/record/flow' },
      ],
    },
  ];
  const setMenuList = [
    {
      title: <Setting />,
      url: '/',
      children: [
        { title: t('record.tab.01.title'), url: '/record/order' },
        { title: t('record.tab.02.title'), url: '/record/plan' },
        { title: t('record.tab.03.title'), url: '/record/order-history' },
        { title: t('record.tab.04.title'), url: '/record/fund' },
        { title: t('record.tab.05.title'), url: '/record/flow' },
      ],
    },
  ];
  useEffect(() => {
    if (isLogin && accountInfo === null) {
      showOpenAccountModal();
    }
  }, [isLogin, accountInfo]);

  return (
    <div className={cx(cs.profileWrap)}>
      {isLogin ? (
        <ul className={cx('header-ul')}>
          <li className={cs.userSection}>
            <ul>
              {menuList.map((item: any, index) => (
                <li key={index}>
                  {item.children ? (
                    <Popover
                      placement="bottom-end"
                      width={240}
                      style={{ paddingLeft: 0, paddingRight: 0, borderRadius: '16px', paddingBottom: '10px' }}
                      content={<DropDownProfileMenu />}
                    >
                      <a>
                        {/* <span className={cs.account}>
                          {showEmail ? showEmail : showTel}
                          <i className={cx("iconfont icon-select_drop",cs.dropDown)}></i>
                        </span> */}
                        {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                      </a>
                    </Popover>
                  ) : (
                    <NavLink to={item.url} activeClassName="active" strict>
                      {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </li>
          {/* <li>
            <ul>
              {orderMenuList.map((item: any, index) => (
                <li key={index}>
                  {item.children ? (
                    <Popover
                      placement="bottom-end"
                      width={180}
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                      content={<DropDownMenu data={item.children} />}
                    >
                      <a>
                        {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                      </a>
                    </Popover>
                  ) : (
                    <NavLink to={item.url} activeClassName="active" strict>
                      {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </li> */}
          {/* <li>
            <ul>
              {setMenuList.map((item: any, index) => (
                <li key={index}>
                  {item.children ? (
                    <Popover
                      placement="bottom-end"
                      width={160}
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                      content={<DropDownSettingMenu />}
                    >
                      <a>
                        {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                      </a>
                    </Popover>
                  ) : (
                    <NavLink to={item.url} activeClassName="active" strict>
                      {item.title} {item.icon ? <span className={cs.icon}>{item.icon}</span> : null}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </li> */}
          {/* 下载 */}
          {/* <li>
            <a href={getExchangeUrl().quanto}>
              <Download style={{ color: theme === 'Dark' ? 'white' : 'black', fontSize: '20px' }} />
            </a>
          </li> */}
        </ul>
      ) : null}

      {/* <div>{visible && <OpenAccountModal visible={visible} hideModel={hideOpenAccountModal} />}</div> */}
    </div>
  );
};

export default observer(Profile);
